import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

export const CHECKPOINT_STYLES = {
  // チェックボックスの垂直位置調整
  CHECKBOX_VERTICAL_OFFSET: '-9px',

  // カード左側のボーダースタイル
  CARD_BORDER_WIDTH: '3px',
  CARD_BORDER_COLOR: colorTokens.blue[600],

  // パディング
  CARD_PADDING_LEFT: 3,
  CARD_PADDING_VERTICAL: 1,

  // フォントサイズ（theme typography: h6=1.125rem, body1=0.875rem, body2=0.8125rem）
  LABEL_FONT_SIZE: '1.125rem',
  POINT_FONT_SIZE: '0.875rem',
  GUIDANCE_LABEL_FONT_SIZE: '0.8125rem',

  // フォントウェイト（theme h6=600だが、チェックポイントラベルは700で強調）
  LABEL_FONT_WEIGHT: 700,

  // 行の高さ
  POINT_LINE_HEIGHT: 1.6,

  // 余白
  LABEL_MARGIN_BOTTOM: 0.25,

  // スペーシング
  CHECKPOINT_SPACING: 2,
  POINTS_PADDING_LEFT: 1,
  CHECKBOX_MARGIN_TOP: 0.5,

  // カラー
  CHECKBOX_COLOR: colorTokens.grey[600],
  CHECKBOX_CHECKED_COLOR: colorTokens.blue[600],
  LABEL_COLOR: colorTokens.grey[900],
  POINT_COLOR: colorTokens.grey[800],
  EMPTY_STATE_COLOR: colorTokens.grey[600],
  GUIDANCE_LABEL_COLOR: colorTokens.special.normalText,

  // 空状態表示
  EMPTY_STATE_FONT_SIZE: '0.875rem',
} as const
